import WrapperFolderStructure from './WrapperFolderStructure';
import backfileIcon from '../../../assets/images/Folder/back.svg';
import Typography from 'components/Atoms/Typography';

function ArtifectFolderDetail({
  handleGoBackClick,
  currentArtefact,
  artefactContentStructure,
  className = '',
}) {
  return (
    <div>
      <div
        className={`ltw-flex ltw-items-center ltw-gap-14px ltw-mt-25px ltw-py-15px ltw-border-b-0.5 ltw-border-horizontol-line-color ${className}`}
      >
        {handleGoBackClick && (
          <div
            onClick={handleGoBackClick}
            onKeyDown={() => {}}
            role="button"
            tabIndex="0"
          >
            <img src={backfileIcon} alt="back" />
          </div>
        )}
        <Typography
          variant="h2"
          color="ltw-text-secondary"
          fontType="ltw-font-medium"
          fontSize="ltw-text-14"
          lineHeight="ltw-leading-17"
        >
          {currentArtefact?.name}
        </Typography>
      </div>
      <WrapperFolderStructure
        artefactContentStructure={artefactContentStructure}
      />
    </div>
  );
}
export default ArtifectFolderDetail;
